// Coach Manager bookings are either charters (PrivateHires) or contracts (line
// runs); the type is encoded as the booking hash prefix, e.g.
// 'private_hire_9_93392_20260715' / 'contract_131_2374_20260715'.

export const VSM_BOOKING_TYPE_OPTIONS = [
  { value: '', text: 'All Bookings' },
  { value: 'private_hire', text: 'Charters' },
  { value: 'contract', text: 'Contracts' },
]

export function matchesBookingType(item, bookingType) {
  if (!bookingType) return true
  const hash = item && item.next_mvmt_booking_hash
  return !!hash && String(hash).indexOf(bookingType + '_') === 0
}

// only CM tenants have typed booking hashes; other sources (FastTrak, manual
// records) carry no prefix, so the type filter is hidden for them
export function hasBookingTypedItems(items) {
  return (items || []).some(
    item => matchesBookingType(item, 'private_hire') || matchesBookingType(item, 'contract')
  )
}
